import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-16 md:py-24" data-id="element-215">
      <div className="mx-auto max-w-4xl px-4" data-id="element-216">
        {/* The Real Problem */}
        <div className="mb-20 text-center" data-id="element-217">
          <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-5xl" data-id="element-218">
            El problema real no sos vos
          </h2>
          <p className="mx-auto mb-8 max-w-2xl text-xl text-gray-600" data-id="element-219">
            No es que no sepas enseñar. No es que no tengas vocación. No es que
            no lo intentes.
          </p>

          <div className="rounded-2xl bg-blue-50 p-8 md:p-12" data-id="element-220">
            <p className="mb-6 text-lg font-medium text-blue-900" data-id="element-221">
              El problema real es este:
            </p>
            <h3 className="text-2xl font-black text-blue-800 md:text-4xl" data-id="element-222">
              👉 Estás sosteniendo el aula sin un sistema que te sostenga a vos.
            </h3>
          </div>
        </div>

        {/* The Demands */}
        <div className="mb-20 grid gap-12 md:grid-cols-2 items-center" data-id="element-223">
          <div data-id="element-224">
            <p className="mb-6 text-xl font-bold text-gray-900" data-id="element-225">
              Te piden que:
            </p>
            <ul className="space-y-4" data-id="element-226">
              {['Mantengas la atención', 'Gestiones emociones', 'Pongas límites', 'Motives', 'Resuelvas conflictos', 'Y sigas con el contenido'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg text-gray-700" data-id="element-227">
                  <div className="flex h-6 w-6 items-center justify-center rounded-full bg-red-100" data-id="element-228">
                    <span className="h-2 w-2 rounded-full bg-red-500" data-id="element-229"></span>
                  </div>
                  {item}
                </li>)}
            </ul>
            <p className="mt-8 text-lg font-semibold text-gray-900" data-id="element-230">
              Todo al mismo tiempo. Todos los días.
            </p>
            <p className="mt-2 text-gray-600" data-id="element-231">
              Sin herramientas claras. Sin frases listas. Sin saber exactamente
              qué decir y qué hacer en el momento.
            </p>
          </div>

          <div className="relative" data-id="element-232">
            <div className="absolute -inset-4 rounded-xl bg-gradient-to-tr from-blue-600 to-purple-600 opacity-20 blur-lg" data-id="element-233"></div>
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1000&auto=format&fit=crop" alt="Docente abrumada" className="relative rounded-xl shadow-2xl grayscale hover:grayscale-0 transition-all duration-500" data-id="element-234" />
          </div>
        </div>

        {/* The Solution Intro */}
        <div className="text-center" data-id="element-235">
          <h2 className="mb-4 text-2xl font-bold text-gray-900" data-id="element-236">
            La solución no es más teoría
          </h2>
          <h3 className="mb-8 text-4xl font-black text-blue-600 md:text-6xl" data-id="element-237">
            ES UN SISTEMA PRÁCTICO PARA EL AULA REAL
          </h3>

          <div className="mx-auto max-w-3xl rounded-xl border-2 border-gray-900 bg-gray-900 p-8 text-white shadow-2xl" data-id="element-238">
            <h4 className="mb-4 text-3xl font-bold text-yellow-400" data-id="element-239">
              MEGA KIT SUPERVIVENCIA DOCENTE
            </h4>
            <p className="text-lg leading-relaxed" data-id="element-240">
              Un sistema completo de recursos prácticos para docentes que
              necesitan respuestas inmediatas, no cursos largos ni teoría
              abstracta.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm font-bold uppercase tracking-wider text-gray-900" data-id="element-241">
              <span className="rounded bg-white px-3 py-1" data-id="element-242">Todo listo</span>
              <span className="rounded bg-white px-3 py-1" data-id="element-243">Todo probado</span>
              <span className="rounded bg-white px-3 py-1" data-id="element-244">
                Todo organizado
              </span>
              <span className="rounded bg-yellow-400 px-3 py-1" data-id="element-245">
                Aplicable en 3 a 10 minutos
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}